var Typeahead = require('./gen/typeahead');

module.exports = Typeahead;
